import React, { useEffect, useState } from "react";
import "./BlogComponent.scss"
import BlogItem from "../components/BlogItem/BlogItem";
import { useHistory } from "react-router";
import { getAllBlogPosts } from "../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useSelector } from "react-redux";
const BlogComponent = () => {
    const history = useHistory()
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const companyDetails = useSelector((state) => state.companyData.company)

    useEffect(() => {
        fetchData()
    }, [])
    const fetchData = async () => {
        setIsLoading(true)
        let id = companyDetails?.ID ?? ''

        await getAllBlogPosts(id).then((response) => {
            if (response.data) {
                setData(response.data)
            } else {
                setData([])
            }
            setIsLoading(false)

        })
    }
    return (
        data && <div className="BlogComponent">
            <div className="BlogComponent-subheader">
                ― OUR JOURNAL ―
            </div>
            <div className="BlogComponent-header">
                RECENT <div className="BlogComponent-header-bold">BLOGS</div>
            </div>
            {isLoading ? <div className="loader-bloglist" /> : <div className="BlogComponent-grid">
                {data?.slice(0, 3).map((item, key) => {
                    return (
                        <BlogItem
                            item={item}
                            key={key} />

                    )
                })
                }
            </div>}
            {data?.length > 3 && <div className="BlogComponent-button"
                onClick={() => {
                    history.push("/blog")
                }}>
                VIEW ALL BLOGS
            </div>}
        </div>
    )

}
export default BlogComponent